<app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
<div *ngIf="!loading" style="display: block">
    <div [chart]="chart"></div>
</div>
<!-- <button (click)="init()">Init</button> -->
<!-- <button (click)="addPoint()">Add Point</button> -->
<!-- <button (click)="init()">Init</button>
<button (click)="addSerie()">Add Serie</button>
<button (click)="removeSerie()">Remove Serie</button>
<button (click)="addPoint()">Add Point</button>
<button (click)="removePoint()">Remove Point</button> -->


<!-- ejemplo
<app-gh-barra-simple
                                *ngIf="banderaGraficoEvento"
                                [dataList]="dataGraProgramados"
                                [loading]=""
                                [dataLabel]="dataLabelGraProgramados"
                                [idComponent]="'idEventoPro'"
                                [title]="'PAROS PROGRAMADOS'"
                                [unidad]="'HORAS(H)'"
                                ></app-gh-barra-simple> -->
